import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d7e8e2c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "",
  style: {
    "height": "100vh",
    "background-color": "#f7f7f7"
  }
};
const _hoisted_2 = {
  style: {
    "width": "98%",
    "margin": "0 auto",
    "box-shadow": "0 0 0.5em #ddd",
    "border-radius": "0.5em",
    "padding-left": "10px",
    "padding-top": "10px",
    "padding-bottom": "10px"
  },
  class: "bg-white"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "",
  class: "text font-bold text-center line-height",
  style: {
    "padding": "5px",
    "margin-top": "10px",
    "margin-right": "10px",
    "background-color": "#f7f7f7"
  }
}, " 微信登录 ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "",
  class: "line-height"
}, "使用微信的方式登录", -1));
const _hoisted_5 = ["disabled"];
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { getWxappid } from "../../../api/index";
import { getLocalPid } from "../../../libs/util";
import Title from "../../../components/title.vue";
export default {
  __name: 'weChat',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const store = useStore();
    const disabled = ref(true);
    const pid = getLocalPid();
    const wxAppId = computed(() => store.state.wxAppId);
    onMounted(() => {
      if (!wxAppId.value) {
        getWxAppIdFn().then(() => {
          disabled.value = false;
        }).catch(err => {
          ElMessage.error(err);
        });
      } else {
        disabled.value = false;
      }
      let urlStr = window.location.href;
      let theRequest = {};
      // 发现url中含有token和userId
      if (urlStr.indexOf("?") != -1) {
        urlStr = urlStr.split("?")[1];
        let strs = urlStr.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
        let msg = JSON.stringify(theRequest);
        ElMessage.success("登录成功");
        localStorage.setItem("ways", "wechat");
        localStorage.setItem("userMes", msg);
        store.commit("login", theRequest);
      }
    });
    const login = () => {
      // 去授权 然后重定向
      let wxRedirectUrl = "https://read.bluebirdabc.com/readapi/user/wxoauthcb";
      let state = pid + ":" + wxAppId.value + ":" + window.location.href;
      window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize" + "?appid=" + wxAppId.value + "&redirect_uri=" + wxRedirectUrl + "&response_type=code" + "&scope=snsapi_userinfo" + "&state=" + state + "#wechat_redirect";
    };
    const getWxAppIdFn = () => {
      disabled.value = true;
      return new Promise((resolve, reject) => {
        getWxappid({
          pid: getLocalPid()
        }).then(res => {
          console.log(res);
          let msg = res.data;
          if (msg.code === 0) {
            resolve();
            store.commit("saveAppId", msg.data.wxAppId);
          } else {
            reject(msg.msg);
          }
        }).catch(() => {
          reject("请求appid失败");
        });
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(Title), _createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", {
        class: "font-bold text-center",
        style: {
          "background-color": "#66afe9",
          "color": "white",
          "width": "99%",
          "padding": "5px",
          "border-radius": "0.3em",
          "margin-top": "5px"
        },
        onClick: _cache[0] || (_cache[0] = $event => login()),
        disabled: disabled.value
      }, _toDisplayString(disabled.value ? "获取appid中..." : "登录"), 9, _hoisted_5)])])], 2);
    };
  }
};